import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ReferenceRateValue } from 'src/features/referenceRateValues/utils/types';

const RESOURCE = '/subscriptions/reference-rate/:referenceRateId/reference-rate-value/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    referenceRateId: string;
}

const queryFn = ({ referenceRateId, ...params }: DTO): Promise<ListResponseAPI<ReferenceRateValue>> => {
    return axios.get(formatResourcePath(RESOURCE, { referenceRateId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_REFERENCE_RATE_VALUES_RESOURCE, useQueryHook as useListReferenceRateValues };
